import { startCase } from 'lodash';

export type TProjectPage = {
  label: string;
  /** The page's section of the project path: /project/<name>/<section>; '' for Project Home */
  section: string;
};

/** The project's pages, by phase - the header's project menus and the breadcrumb under it */
export const projectMenu: Record<string, TProjectPage[]> = {
  'pre-pro': [
    { label: 'Project Home', section: '' },
    { label: 'Session Estimator', section: 'session-estimator' },
    { label: 'Usage Estimator', section: 'usage-estimator' },
    { label: 'Estimates', section: 'estimate' },
  ],
  production: [
    { label: 'Licensing & Rights', section: 'licensing-rights' },
    { label: 'Hire Talent', section: 'hire-talent' },
    { label: 'Time Tracking', section: 'time-tracking' },
    { label: 'Pay Sessions', section: 'pay-sessions' },
    { label: 'Talent Manager', section: 'talent-manager' },
    { label: 'Holding Fees', section: 'holding-fees' },
  ],
  'post-production': [
    { label: 'Edits & Final Cast', section: 'edits' },
    // { label: 'Pay Residuals', section: 'pay-residuals' },
    // { label: 'Commercial History', section: 'commercial-history' },
    { label: 'Asset Library', section: 'asset-library' },
  ],
  // reports: [
  //   { label: 'Project Report', section: 'project-report' },
  //   { label: 'Talent Report', section: 'talent-report' },
  //   { label: 'Residuals Report', section: 'residuals-report' },
  // ],
};

/** "Pre Pro" for 'pre-pro' */
export const phaseLabel = (phase: string) => startCase(phase.replaceAll(/-/g, ' '));

/** The phase and page a project section belongs to, if it's one of the menus' pages */
export const findProjectPage = (section: string | undefined) => {
  if (section === undefined) return undefined;
  for (const [phase, pages] of Object.entries(projectMenu)) {
    const page = pages.find((p) => p.section === section);
    if (page) return { phase, page };
  }
  return undefined;
};
